




import { computed, defineComponent } from '@nuxtjs/composition-api';
import { useI18n } from '~/features/i18n';
import { useProductContext } from '~/features/productContext';
import { useCategories } from '~/features/categories';

export default defineComponent({
  name: 'ProductPageBreadcrumb',
  props: {
    threshold: {
      type: Number,
      default: null,
    },
  },
  setup(props) {
    const { product } = useProductContext();
    const { findBySlug, findByName } = useCategories();
    const { t } = useI18n();
    const excludePaths = ['brands', 'best-sellers', 'new-arrivals'];

    const items = computed(() => {
      const { categories, name, url_key } = product.value || {};
      if (!categories?.length) {
        return [];
      }

      // We're intersted in categories paths only
      const exactPath = categories.filter(category => {
        const path = category?.url_path?.split('/').shift();
        return !excludePaths.includes(path as string);
      });

      // Get the last one that has the full path
      const slugs = exactPath?.pop()?.url_path?.split('/');

      const paths = slugs?.map(slug => {
        // We search for the category within the categoryTree either by slug or by name
        // because some categories have a different 'url_key' than their names
        // for example 'Perfumes' has url_key = 'fragrances'
        const category = findBySlug(slug) || findByName(slug);

        return {
          label: category?.name,
          path: `/${category?.url}`,
        };
      });

      const breadcrumbItems = [
        {
          label: t('home').toString(),
          path: '/',
        },
      ].concat(paths as { label: string; path: string }[]);

      breadcrumbItems.push({
        label: name as string,
        path: `/${url_key}`,
      });

      return props.threshold ? breadcrumbItems.slice(1, props.threshold) : breadcrumbItems;
    });

    return {
      items,
    };
  },
});
